var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNeutral(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 0.179443C5.88333 0.179443 0.5 5.56278 0.5 12.1794C0.5 18.7961 5.88333 24.1794 12.5 24.1794C19.1167 24.1794 24.5 18.7961 24.5 12.1794C24.5 5.56278 19.1167 0.179443 12.5 0.179443ZM5.16667 9.95722C5.16667 9.34389 5.66389 8.84611 6.27778 8.84611H9.88889C10.5028 8.84611 11 9.34389 11 9.95722C11 10.5706 10.5028 11.0683 9.88889 11.0683H6.27778C5.66389 11.0683 5.16667 10.5711 5.16667 9.95722ZM16.9444 17.5683H8.05556C7.44167 17.5683 6.94444 17.0711 6.94444 16.4572C6.94444 15.8433 7.44167 15.3461 8.05556 15.3461H16.9444C17.5583 15.3461 18.0556 15.8439 18.0556 16.4572C18.0556 17.0706 17.5583 17.5683 16.9444 17.5683ZM18.7222 11.0683H15.0556C14.4417 11.0683 13.9444 10.5711 13.9444 9.95722C13.9444 9.34333 14.4417 8.84611 15.0556 8.84611H18.7222C19.3361 8.84611 19.8333 9.34389 19.8333 9.95722C19.8333 10.5706 19.3361 11.0683 18.7222 11.0683Z",
    fill: "#407DBB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeutral);
export default __webpack_public_path__ + "static/media/neutral.f80374ef4636c9a03d95fe4739ae3f94.svg";
export { ForwardRef as ReactComponent };